import React, { useEffect, useState, useReducer, useRef, useCallback } from 'react';

import { connect } from 'react-redux';
import { getCampDetailService } from '../../services/userServices';
import { productBookingsService } from '../../services/otherService';
import { getProgramsListService } from '../../services/otherService';
import { getProductsListService } from '../../services/otherService';
import { getPurchasedAdditionalExperiences, getAdditionalExperiencesByCampCode } from '../../services/programService';
import { Empty, notification } from 'antd';
import { Link } from 'react-router-dom';
import PaginatedComponent from '../common/Pagination/PaginationComponent';
import { ProgramLoader } from '../reuse/SVG';
import { Dropdown, Modal } from 'react-bootstrap';
import { dateFormat, formatTimestamp, debounce, SEARCH_DEBOUNCE_DELAY } from '../../helper';
import Select from 'react-select';
import { adminBookingListForProductsService, itemPurchaseUpdateProductBooking } from '../../services/programService';
import { getProductDeailsService } from '../../services/onlineStoreService';
import { getColors2, getSizes } from '../online-store/OnlineStore';
import { fBookingDateFilterAction, fCamperNameFilterAction, fEmailFilterAction, fProductNameFilterAction, fTsizeFilterAction, fUserNameFilterAction, fProgramNameFilterAction, fStatusFilterAction } from '../../store/allProductFilterState';
import { CustomDateRange } from '../reuse/FormControls';
import moment from 'moment';



const initialItemDetails = {
    itemId:'',
    purchaseId:''
  };
  const setItemDetails = (state, action) => {
    return { ...state, ...action.payload }
};

const ITEM_STATUS = new Map([
    [2, {status: 'CANCELED', background:'bkg-primary'}],
    [3, {status: 'CANCELED AND REFUNDED', background:'bg-success'}],
    [4, {status:'REFUNDED', background:'bg-primary'}],
  ]);

const BOOKING_TYPES = {
    PRODUCT: 'product',
    ADDITIONAL_EXPERIENCE: 'additionalExperience'
};

const ProductBookings = props => {
    const [loader, setLoader] = useState(false);
    const [bookings, setBookings] = useState([]);
    const [search, setSearch] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [page, setPage] = useState(1);
    const [campId, setCampId] = useState('');
    const [count, setCount] = useState(0);
    const [selectedBookingId, setSelectedBookingId] = useState(null);
    const [isEditmodal, setIsEditModal] = useState(false);
    const [bookingList, setBookingList] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState({});
    const [itemDetails, dispatch] = useReducer(setItemDetails, initialItemDetails);
    const [showProductEditDropDown, setProductEditDropDown] = useState(false);
    const [activeItem, setActiveItem]= useState({})
    const [selectedColor, setSelectedColor] = useState('');
    const [selectedSize, setSelectedSize] = useState('');
    const [isSizeAvailable,setIsSizeAvailable] = useState(false)
    const [modalLoader, setModalLaoder] = useState(false)
    const [missingCamperError, setMissingCamperError] = useState('')
    const [programs, setPrograms] = useState([]);
    const [products, setProducts] = useState([]);
    const [additionalExperiences, setAdditionalExperiences] = useState([]);

    // State for toggle between Product Bookings and Additional Experience Bookings
    const [activeBookingType, setActiveBookingType] = useState(BOOKING_TYPES.PRODUCT);

    // State for Additional Experience Bookings
    const [aeBookings, setAeBookings] = useState([]);
    const [aeAllBookings, setAeAllBookings] = useState([]); // Store all data for filtering
    const [aeSearch, setAeSearch] = useState('');
    const [aeSearchInput, setAeSearchInput] = useState('');
    const [aePage, setAePage] = useState(1);
    const [aeCount, setAeCount] = useState(0);
    const [aeLoader, setAeLoader] = useState(false);
    const aeInitialMount = useRef(true);

    // Filter states for Additional Experience
    const [aeExperienceNameFilter, setAeExperienceNameFilter] = useState(null);
    const [aeProgramNameFilter, setAeProgramNameFilter] = useState([]);
    const [aeBookingDateFilter, setAeBookingDateFilter] = useState({ startDate: '', endDate: '' });
    const [aePaymentFilter, setAePaymentFilter] = useState(false);


    const limit = 10;

    const debouncedSearch = useCallback(debounce(value => { setSearch(value); setPage(1); }, SEARCH_DEBOUNCE_DELAY), []);
    const debouncedAeSearch = useCallback(debounce(value => { setAeSearch(value); setAePage(1); }, SEARCH_DEBOUNCE_DELAY), []);

    // API call to fetch Additional Experience bookings
    const getAdditionalExperienceBookings = () => {
        setAeLoader(true);

        // Build request body for POST
        const requestBody = {
            campCode: props.userProfile.campCode,
            search: aeSearch || "",
            page: aePage - 1,
            limit: limit
        };

        // Apply filters if search is empty
        if (!aeSearch || aeSearch.trim() === "") {
            if (aeExperienceNameFilter?.value) {
                requestBody.title = aeExperienceNameFilter.value;
            }
            if (aeProgramNameFilter && aeProgramNameFilter.length > 0) {
                requestBody.programIds = aeProgramNameFilter.map(p => p.value);
            }
            if (aeBookingDateFilter?.startDate && aeBookingDateFilter?.endDate) {
                requestBody.bookingStartDate = aeBookingDateFilter.startDate;
                requestBody.bookingEndDate = aeBookingDateFilter.endDate;
            }
            if (aePaymentFilter) {
                requestBody.isPayment = true;
            }
        }

        getPurchasedAdditionalExperiences(requestBody)
            .then(res => {
                setAeLoader(false);
                if (res.data.statusCode) {
                    const data = res.data.responseData?.data || [];
                    // Use 'total' field from API response for pagination
                    const totalCount = res.data.responseData?.total || res.data.responseData?.totalCount || 0;
                    setAeBookings(data);
                    setAeAllBookings(data);
                    setAeCount(totalCount);
                }
            })
            .catch(err => {
                setAeLoader(false);
                console.log(err.message);
            });
    };

    // Apply filters for Additional Experience (calls API with filters)
    const applyAeFilters = () => {
        setAePage(1);
        getAdditionalExperienceBookings();
    };

    // Clear all Additional Experience filters
    const clearAeFilters = () => {
        setAeExperienceNameFilter(null);
        setAeProgramNameFilter([]);
        setAeBookingDateFilter({ startDate: '', endDate: '' });
        setAePaymentFilter(false);
        setAePage(1);

        // Fetch data with cleared filters
        setAeLoader(true);
        const requestBody = {
            campCode: props.userProfile.campCode,
            search: aeSearch || "",
            page: 0,
            limit: limit
        };

        getPurchasedAdditionalExperiences(requestBody)
            .then(res => {
                setAeLoader(false);
                if (res.data.statusCode) {
                    const data = res.data.responseData?.data || [];
                    const totalCount = res.data.responseData?.total || res.data.responseData?.totalCount || 0;
                    setAeBookings(data);
                    setAeAllBookings(data);
                    setAeCount(totalCount);
                }
            })
            .catch(err => {
                setAeLoader(false);
                console.log(err.message);
            });
    };

    // Handle Additional Experience booking date filter change
    const handleAeBookingDateChange = (dates) => {
        if (Array.isArray(dates) && dates.length === 2) {
            setAeBookingDateFilter({
                startDate: dates[0] ? dates[0].valueOf() : '', // Convert moment to timestamp
                endDate: dates[1] ? dates[1].valueOf() : ''
            });
        } else {
            setAeBookingDateFilter({ startDate: '', endDate: '' });
        }
    };

    // Get experience names from additional experiences list for filter dropdown
    const getExperienceNameOptions = () => {
        return additionalExperiences.map(exp => ({
            label: exp.title,
            value: exp.title,
        }));
    };

    // Get program names from programs list for Additional Experience filter
    const getAeProgramOptions = () => {
        return programs.map(p => ({
            label: p.programName,
            value: p.programId,
        }));
    };

    // Handle booking type toggle
    const handleBookingTypeChange = (type) => {
        setActiveBookingType(type);
        // Reset search when switching tabs
        if (type === BOOKING_TYPES.PRODUCT) {
            setAeSearch('');
            setAeSearchInput('');
        } else {
            setSearch('');
            setSearchInput('');
        }
    };

      const handleToggleSubItem= (objId, ) => {
        if (selectedBookingId === objId) {
          setSelectedBookingId(null);
        } else {
          setSelectedBookingId(objId);
        }
      };

    const getBookingList = () => {
        setLoader(true)
        // let query = `?search=${search}&page=${page - 1}&limit=${limit}&campCode=${props.userProfile.campCode}`;
        const params = {
            search: search || "",
            page: page - 1,
            limit: limit,
            campCode: props.userProfile.campCode,
        };

        // Prioritize search over filters
        if (search && search.trim() !== "") {
            params.search = search.trim();
        } else {
            // Otherwise, apply filters as usual
            params.search = "";
            params.programIds = Array.isArray(props.f_programName)
                ? props.f_programName.map(p => p.value)
                : [];
            params.status = props.f_status?.value
                ? Number(props.f_status.value)
                : undefined;
            params.bookingStartDate = props.f_bookingDate?.startDate || undefined;
            params.bookingEndDate = props.f_bookingDate?.endDate || undefined;
            params.productName = props.f_productName?.value || undefined;
        }
        setLoader(true)
        setBookings([]);
        productBookingsService(params).then(res => {
            setLoader(false)
            if(res.data.statusCode){
                setBookings(res.data.responseData.result)
                setCount(res.data.responseData.totalCount);
            }
        })  
    }

    // Helper function to clear all filters if clear all is executed
    const getBookingListWithoutFilters = (customParams = {}) => {
        const params = {
            search: search || "",
            page: page - 1,
            limit,
            campCode: props.userProfile.campCode,
            programIds: props.f_programName?.map(p => p.value) || [],
            status: props.f_status ? Number(props.f_status.value) : undefined,
            productName: props.f_productName?.value || undefined,
            bookingStartDate: props.f_bookingDate?.startDate || undefined,
            bookingEndDate: props.f_bookingDate?.endDate || undefined,
            ...customParams,
        };

        setLoader(true);
        setBookings([]);
        productBookingsService(params)
            .then(res => {
            setLoader(false);
            if (res.data.statusCode) {
                setBookings(res.data.responseData.result);
                setCount(res.data.responseData.totalCount);
            }
            })
            .catch(() => setLoader(false));
        };


    const getSelectedItem = (ItemId) => {
        setModalLaoder(true)
        const params = `/${ItemId}`
        getProductDeailsService(params).then(res => {
            if(res.data.statusCode){
                setActiveItem(res.data.responseData.result)
                const sizeArray = getSizes(res.data.responseData.result.sizes)
                setIsSizeAvailable(sizeArray?.length > 0 ? true : false)
                setModalLaoder(false)
            }
        }).catch(() => setModalLaoder(false)).finally(() => setModalLaoder(false))
    }
    const getCampDetails = () => {
        const query = `?campCode=${props.userProfile.campCode}`;
                getCampDetailService(query).then((res) => {
                    if(res.data.statusCode){
                        setProductEditDropDown(res.data.responseData.result?.showProductEditButton) 
                    }
                    setLoader(false)
                }).catch(e => console.log(e.message)).finally(() => setLoader(false))
    }

    // API call to fetch all programs for a camp
    const getProgramsList = () => {
        setLoader(true);
        const query = `?campCode=${props.userProfile.campCode}`;

        getProgramsListService(query)
            .then(res => {
                setLoader(false);
                if (res.data.statusCode) {
                    setPrograms(res.data.responseData || []);
                }
            })
            .catch(err => {
                setLoader(false);
            });
    };

    // API call to fetch all products for a camp
    const getProductsList = () => {
        setLoader(true);
        const query = `?campCode=${props.userProfile.campCode}`;

        getProductsListService(query)
            .then(res => {
                setLoader(false);
                if (res.data.statusCode) {
                    setProducts(res.data.responseData || []);
                }
            })
            .catch(err => {
                setLoader(false);
            });
    };

    // API call to fetch all additional experiences for a camp
    const getAdditionalExperiencesList = () => {
        const query = `?campCode=${props.userProfile.campCode}`;

        getAdditionalExperiencesByCampCode(query)
            .then(res => {
                if (res.data.statusCode) {
                    setAdditionalExperiences(res.data.responseData || []);
                }
            })
            .catch(err => {
                console.log(err.message);
            });
    };


    useEffect(() => {
        getBookingList();
    }, [search, page, campId])
    // , props.f_programName, props.f_status, props.f_bookingDate.startDate, props.f_bookingDate?.endDate, props.f_productName
    useEffect(() => {
        getCampDetails();
    }, [])

    // API call to fetch all programs for a camp
    useEffect(() => {
        getProgramsList();
    }, [])

    // API call to fetch all products for a camp
    useEffect(() => {
        getProductsList();
    }, [])

    // API call to fetch all additional experiences for a camp
    useEffect(() => {
        getAdditionalExperiencesList();
    }, [])

    // API call to fetch Additional Experience bookings on mount
    useEffect(() => {
        getAdditionalExperienceBookings();
        aeInitialMount.current = false;
    }, [])

    // Fetch Additional Experience bookings when search or page changes
    useEffect(() => {
        // Skip initial mount (handled by previous useEffect)
        if (!aeInitialMount.current) {
            getAdditionalExperienceBookings();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aeSearch, aePage])

    const editExistingDetailsOfProduct = (userId, bookingId, programId, itemId, purchaseId, camperId ) => {
        setIsEditModal(true)
        const params = `?userId=${userId}&campCode=${props.userProfile.campCode}`
        adminBookingListForProductsService(params).then((res) => {
            if(res.data.statusCode){
                const requiredBookingList = res.data.responseData.result.filter( (item) => {
                    if(bookingId === item?.bookingId && programId === item?.programId){
                        return true;
                    }else if(bookingId){
                        return bookingId === item?.bookingId
                    }else{
                        return false; 
                    }
                })
                dispatch({payload:{itemId, purchaseId}});
                setBookingList((requiredBookingList?.length > 0) ? requiredBookingList : res.data.responseData.result);
                setSelectedProgram((requiredBookingList?.length )? requiredBookingList.filter(item => item.camperId === camperId)[0]: {})
                setIsEditModal(true)
            }
        })
        getSelectedItem(itemId);

    }
    const handleColorSelect = (e) => {
        setSelectedSize(e)
        setSelectedColor('')
    }
    const SaveEditDetails = () => {
        if(!selectedProgram?.camperId){
            setMissingCamperError('Camper is not associated with this product. Please contact CampsEZ admin for support.')
            return 
        }
        let data = {
            purchaseId: itemDetails.purchaseId,
            itemId: itemDetails.itemId,
            bookingId: selectedProgram.bookingId,
            camperId: selectedProgram.camperId,
            programId: selectedProgram.programId,
            sizes:selectedSize.value,
            color:selectedColor.value
          }
        itemPurchaseUpdateProductBooking(data).then( res => {
            if(res.data.statusCode) {
                getBookingList();
                setIsEditModal(false)
                notification.open({
                    description: res?.data?.responseData?.message,
                });
            }else{
                setIsEditModal(false)
                setSelectedProgram({})
                notification.open({
                    description: res?.data?.responseData?.message,
                });
                
            }
        })
        
    }
    const onCloseUpdateProductModal = () => { 
        setIsEditModal(false)
        setSelectedProgram({})
        setActiveItem({})
        setSelectedColor('')
        setSelectedSize('')
        setIsSizeAvailable(false)
    }
    return(
        <>
        <style>
            {`
                .info-icon-tooltip:hover + .hover-tooltip {
                    opacity: 1 !important;
                    visibility: visible !important;
                }
            `}
        </style>

        <Modal
        size='lg'
            show={isEditmodal}
            animation={false}
            centered>
            <Modal.Header>
                <span> Update Product Booking Details</span>
                <span className="modal_close" onClick={onCloseUpdateProductModal}><i className="icon-cross" /></span>
            </Modal.Header>
            <Modal.Body>
               {modalLoader ? <div className="page_sm_loader"><ProgramLoader /></div>:
                (!showProductEditDropDown && missingCamperError) ? <h4 className='color_red'>{missingCamperError}</h4> :

                <div className='p-4'>
                    {showProductEditDropDown  && 
                        <>
                            <label>Update Product Details (Program Name - Booking Number - Camper Name )</label>
                            <Select
                                placeholder="Select Program- Booking Number - Camper Name"
                                onChange={e => setSelectedProgram(e)}
                                options={bookingList.filter(i => i.camperId !== selectedProgram?.camperId).map(i => ({...i, label: `${i.programName} - ${i.bookingNumber} - ${i.camperName}`, value: i._id}))}
                                value={(selectedProgram && Object.keys(selectedProgram)?.length> 0) ? {label:`${selectedProgram.programName} - ${selectedProgram.bookingNumber} - ${selectedProgram.camperName}`, value: selectedProgram._id} : '"Select Program- Booking Number - Camper Name"'} 
                                />
                            <hr/>
                        </>

                    }
                 {isSizeAvailable ?
                        <>
                        <label>Update Size </label>
                            <Select
                                placeholder="Select Size"
                                onChange={e => handleColorSelect(e)}
                                options={getSizes(activeItem.sizes)}
                                />
                            <hr/>
                        <label>Update Color</label>
                            <Select
                                placeholder="Select Color"
                                onChange={e => setSelectedColor(e)}
                                options={getColors2(activeItem.sizes, selectedSize.value)}
                                value={selectedColor}
                                />
                    
                    </>
                   : <div className='text-center'>
                       <h3> No Size/Color available</h3>
                     </div>
                        
                       }
                   {(showProductEditDropDown || isSizeAvailable) ? 
                    <div className='text-center'>    
                        <span type="button" className="btn btn-primary m-4" onClick = {SaveEditDetails}>Save</span> 
                    </div>
                    : ""
                    }
                </div>
                }
            </Modal.Body>
        </Modal>
        <div className="page_wrapper">

            <div className="page_card">


                <div className='container'>
                    {/* Toggle Buttons */}
                    <div className="d-flex mb-3 mt-4" style={{ gap: '15px' }}>
                        <button
                            className={`btn ${activeBookingType === BOOKING_TYPES.PRODUCT ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => handleBookingTypeChange(BOOKING_TYPES.PRODUCT)}
                        >
                            Product Bookings
                        </button>
                        <button
                            className={`btn ${activeBookingType === BOOKING_TYPES.ADDITIONAL_EXPERIENCE ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => handleBookingTypeChange(BOOKING_TYPES.ADDITIONAL_EXPERIENCE)}
                        >
                            Additional Experience Bookings
                        </button>
                    </div>

                    <div className="d-flex align-items-center justify-content-between page_card_header">
                        <h4>
                            {activeBookingType === BOOKING_TYPES.PRODUCT ? 'Product Bookings' : (
                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    Additional Experience Bookings
                                    <span style={{ position: 'relative', display: 'inline-block', verticalAlign: 'middle', marginBottom: '4px' }}>
                                        <span
                                            className="info-icon-tooltip"
                                            style={{
                                                cursor: 'pointer',
                                                color: '#17a2b8',
                                                fontWeight: 'bold',
                                                display: 'inline-block',
                                                width: '18px',
                                                height: '18px',
                                                borderRadius: '50%',
                                                border: '2px solid #17a2b8',
                                                textAlign: 'center',
                                                lineHeight: '14px',
                                                fontSize: '12px'
                                            }}
                                        >
                                            i
                                        </span>
                                        <span
                                            className="hover-tooltip"
                                            style={{
                                                position: 'absolute',
                                                top: '125%',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                backgroundColor: '#333',
                                                color: '#fff',
                                                padding: '8px 12px',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                whiteSpace: 'nowrap',
                                                opacity: 0,
                                                visibility: 'hidden',
                                                transition: 'opacity 0.3s, visibility 0.3s',
                                                zIndex: 1000,
                                                pointerEvents: 'none'
                                            }}
                                        >
                                            Additional experience booking data only includes active bookings
                                        </span>
                                    </span>
                                </span>
                            )}
                        </h4>
                        <div className="search_wrap">
                            <i className="icon-search" />
                            {activeBookingType === BOOKING_TYPES.PRODUCT ? (
                                <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    placeholder="Search"
                                    value={searchInput}
                                    onChange={e => { setSearchInput(e.target.value); debouncedSearch(e.target.value); }} />
                            ) : (
                                <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    placeholder="Search"
                                    value={aeSearchInput}
                                    onChange={e => {
                                        setAeSearchInput(e.target.value);
                                        debouncedAeSearch(e.target.value);
                                    }} />
                            )}
                        </div>
                    </div>
                </div>

                <div className="page_card_body">
                    {/* Product Bookings Filter */}
                    {activeBookingType === BOOKING_TYPES.PRODUCT && (
                    <div className='d-flex justify-content-end'>
                        <Dropdown className="cm_filter">
                                        <Dropdown.Toggle variant="primary" className="pl-4 pr-4">
                                        <i className="icon-filter" /> Filter
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <div className="form-group">
                                                <label>Product Name</label>
                                                <Select
                                                    isClearable
                                                    className="form-control"
                                                    placeholder="Select"
                                                    classNamePrefix="cm_select"
                                                    onChange={e => props.fProductNameFilterAction(e)}
                                                    value={props.f_productName ? ({label: props.f_productName.label, value: props.f_productName.value}) : null}
                                                    options={products.map(p => ({
                                                        label: p.productName,
                                                        value: p.productName,
                                                    }))}
                                                />

                                            </div>


                                            <div className="form-group">
                                            <label>Booking Date</label>
                                            <CustomDateRange
                                                error={""}
                                                disabledDate={''}
                                                value={
                                                props.f_bookingDate?.startDate && props.f_bookingDate?.endDate
                                                    ? [
                                                        moment(props.f_bookingDate.startDate),
                                                        moment(props.f_bookingDate.endDate),
                                                    ]
                                                    : []
                                                }
                                                change={e => props.fBookingDateFilterAction(e)}
                                            />
                                            </div>

                                            <div className="form-group">
                                                <label>Status</label>
                                                <Select
                                                    isClearable
                                                    className="form-control"
                                                    placeholder="Select"
                                                    classNamePrefix="cm_select"
                                                    onChange={e => props.fStatusFilterAction(e)}
                                                    value={props.f_status ? { label: props.f_status.label, value: props.f_status.value } : ''}
                                                    options={[
                                                    { label: "Successful", value: 1 },
                                                    { label: "Cancelled", value: 2 },
                                                    { label: "Cancelled With Refund ", value: 3 },
                                                    { label: "Refunded", value: 4 },
                                                    ]}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Program Name</label>
                                                <Select
                                                    isClearable
                                                    isMulti
                                                    className="form-control"
                                                    placeholder="Select"
                                                    classNamePrefix="cm_select"
                                                    onChange={e => props.fProgramNameFilterAction(e)}
                                                    value={Array.isArray(props.f_programName) ? props.f_programName : []}
                                                    options={programs.map(p => ({
                                                        label: p.programName,
                                                        value: p.programId,
                                                    }))}
                                                />
                                            </div>

                                            {/* <div className="form-group">
                                                <label>T-shirt Size</label>
                                                <Select
                                                    isClearable
                                                    className="form-control"
                                                    placeholder="Select"
                                                    classNamePrefix="cm_select"
                                                    onChange={e => props.fTsizeFilterAction(e)}
                                                    value={props.f_tsize ? ({label: props.f_tsize .label, value: props.f_tsize .value}) : ''}
                                                    options={[{label: 'item', value: 'item'}]} />
                                            </div> */}

                                            {/* <div className="form-group">
                                                <label>Camper Name</label>
                                                <Select
                                                    isClearable
                                                    className="form-control"
                                                    placeholder="Select"
                                                    classNamePrefix="cm_select"
                                                    onChange={e => props.fCamperNameFilterAction(e)}
                                                    value={props.f_camperName ? ({label: props.f_camperName.label, value: props.f_camperName.value}) : ''}
                                                    options={[{label: 'item', value: 'item'}]} />
                                            </div> */}
                                            {/* <div className="form-group">
                                                <label>User Email</label>
                                                <Select
                                                    isClearable
                                                    className="form-control"
                                                    placeholder="Select"
                                                    classNamePrefix="cm_select"
                                                    onChange={e => props.fEmailFilterAction(e)}
                                                    value={props.f_email ? ({label: props.f_email.label, value: props.f_email.value}) : ''}
                                                    options={[{label: 'item', value: 'item'}]} />
                                            </div>


                                            <div className="form-group">
                                                <label>User Name</label>
                                                <Select
                                                    isClearable
                                                    className="form-control"
                                                    placeholder="Select"
                                                    classNamePrefix="cm_select"
                                                    onChange={e => props.fallergyBookingFilterAction(e)}
                                                    value={props.f_userName ? ({label: props.f_userName.label, value: props.f_userName.value}) : ''}
                                                    options={[{label: 'item', value: 'item'}]} />
                                            </div> */}

                                            <div className="d-flex justify-content-between cm_round_btn">
                                                <button
                                                    onClick={() => {
                                                        props.fProgramNameFilterAction([]);
                                                        props.fStatusFilterAction('');
                                                        props.fProductNameFilterAction('');
                                                        props.fBookingDateFilterAction({ startDate: '', endDate: '' });
                                                        setPage(1);
                                                        getBookingListWithoutFilters({  // Helper function to clear all filters if clear all is executed
                                                            programIds: [],
                                                            status: undefined,
                                                            productName: undefined,
                                                            bookingStartDate: undefined,
                                                            bookingEndDate: undefined,
                                                            search: search || "",
                                                        });
                                                        // getBookingList();
                                                    }}
                                                    className="btn btn-light w-100 mr-1 rounded-5"
                                                >
                                                    Clear All
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        setPage(1);
                                                        getBookingList(); // re-fetch data with applied filters
                                                    }}
                                                    className="btn btn-primary w-100 ml-1 rounded-5"
                                                >
                                                    Apply Filter
                                                </button>
                                            </div>
                                        </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    )}

                    {/* Additional Experience Bookings Filter */}
                    {activeBookingType === BOOKING_TYPES.ADDITIONAL_EXPERIENCE && (
                    <div className='d-flex justify-content-end'>
                        <Dropdown className="cm_filter">
                            <Dropdown.Toggle variant="primary" className="pl-4 pr-4">
                                <i className="icon-filter" /> Filter
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <div className="form-group">
                                    <label>Experience Name</label>
                                    <Select
                                        isClearable
                                        className="form-control"
                                        placeholder="Select"
                                        classNamePrefix="cm_select"
                                        onChange={e => setAeExperienceNameFilter(e)}
                                        value={aeExperienceNameFilter}
                                        options={getExperienceNameOptions()}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Booking Date</label>
                                    <CustomDateRange
                                        error={""}
                                        disabledDate={''}
                                        value={
                                            aeBookingDateFilter?.startDate && aeBookingDateFilter?.endDate
                                                ? [
                                                    moment(aeBookingDateFilter.startDate),
                                                    moment(aeBookingDateFilter.endDate),
                                                ]
                                                : []
                                        }
                                        change={handleAeBookingDateChange}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Program Name</label>
                                    <Select
                                        isClearable
                                        isMulti
                                        className="form-control"
                                        placeholder="Select"
                                        classNamePrefix="cm_select"
                                        onChange={e => setAeProgramNameFilter(e || [])}
                                        value={aeProgramNameFilter}
                                        options={getAeProgramOptions()}
                                    />
                                </div>

                                <div className="form-group">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="aePaymentFilter"
                                            checked={aePaymentFilter}
                                            onChange={(e) => setAePaymentFilter(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="aePaymentFilter">
                                            Individual Purchases Only
                                        </label>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between cm_round_btn">
                                    <button
                                        onClick={clearAeFilters}
                                        className="btn btn-light w-100 mr-1 rounded-5"
                                    >
                                        Clear All
                                    </button>
                                    <button
                                        onClick={applyAeFilters}
                                        className="btn btn-primary w-100 ml-1 rounded-5"
                                    >
                                        Apply Filter
                                    </button>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    )}



                    {/* Product Bookings Table */}
                    {activeBookingType === BOOKING_TYPES.PRODUCT && (
                        <>
                        {loader ? <div className="program_loader"><ProgramLoader /></div>  :
                            <div className="table_responsive_wrap mt-4 text-center">
                            <div className="table-responsive">

                                <table className="table table-bordered table-striped" id="section-to-print">

                                    <thead>
                                        <tr>
                                            <th><span className="t_text">S.No</span></th>
                                            <th><span className="t_text">Options</span></th>
                                            <th><span className="t_text">Booking Date</span></th>
                                            <th><span className="t_text">Program Name</span></th>
                                            <th><span className="t_text">Product Image</span></th>
                                            <th><span className="t_text">Product Name</span></th>
                                            <th><span className="t_text">Product sizes / colors</span></th>
                                            <th><span className="t_text">Quantity</span></th>
                                            <th><span className="t_text">Price</span></th>
                                            <th><span className="t_text">User Name</span></th>
                                            <th><span className="t_text">Camper Name</span></th>
                                            <th><span className="t_text">User Email</span></th>
                                            <th><span className="t_text">Transaction Id</span></th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            bookings.map((booking, i) => (
                                                <>
                                                <tr key={booking.transaction_id}>
                                                    <td><span className="t_text">{((i + 1) + ((page - 1) * limit))}</span></td>
                                                    <td>
                                                    <span
                                                            type="button"
                                                            className="btn btn-outline-primary"
                                                            onClick = {() => editExistingDetailsOfProduct(booking?.users?.userId, booking.bookingId,booking.programId, booking.itemId, booking.purchaseId, booking.camperId)}>
                                                            Update
                                                        </span>
                                                        {
                                                            booking?.itemStatus > 1 &&
                                                            <>
                                                                <hr />
                                                                <small className={`rounded-pill ${ITEM_STATUS.get(booking.itemStatus).background} p-1 text-white`}>
                                                                    {ITEM_STATUS.get(booking.itemStatus).status}
                                                                </small>
                                                            </>
                                                        }

                                                    </td>
                                                    <td>
                                                        <span className="t_text">{formatTimestamp(booking.orderedDate)}</span>
                                                        { booking?.subItems?.length > 0 &&
                                                        <button
                                                            className={`btn btn-link m-3`}
                                                            onClick={() => handleToggleSubItem(booking?._id, booking?.subItems)}>
                                                            {selectedBookingId === booking._id ? 'Hide Add-ons' : 'Show Add-ons'}
                                                        </button>
                                                        }
                                                    </td>
                                                    <td>{booking?.programName ? booking?.programName : "N/A"}</td>
                                                    <td><span className="t_text">
                                                    <div className='product_wide_card_img'>
                                                        <img src={booking.image[0]} />
                                                    </div>
                                                    </span></td>
                                                    <td><span className="t_text">{booking.name}</span></td>
                                                    <td><span className="t_text">
                                                        {booking.sizes} /  {booking.color}
                                                    </span></td>
                                                    <td><span className="t_text">{booking.quantity}</span></td>
                                                    <td><span className="t_text">${booking.itemPrice.toFixed(2)}</span></td>
                                                    <td><span className="t_text">{booking.users.name}</span></td>
                                                    <td>
                                                        <span className="t_text">
                                                            {!(booking.bookingId && booking.programId && booking.camperId) ?
                                                            booking.camperName :
                                                            <Link to={`/bookings/${booking.bookingId}/${booking.camperId}/${booking.programId}`}>
                                                                {booking.camperName}
                                                            </Link>
                                                            }
                                                        </span>
                                                        {/* {!(booking.bookingId && booking.programId && booking.camperId) &&

                                                        } */}
                                                    </td>
                                                    <td><span className="t_text">{booking.users.email}</span></td>
                                                    <td><span className="t_text">{booking.transaction_id}</span></td>

                                                </tr>

                                                {
                                                (booking?.subItems?.length > 0  && selectedBookingId === booking._id) &&
                                                booking?.subItems?.map( (item, index) =>
                                                    <tr className="table-secondary" key={item.itemId}>
                                                        <td><span className="t_text">{`${i + 1}.${((index + 1) + ((page - 1) * limit))}`}</span></td>
                                                        <td></td>
                                                        <td><span className="t_text">{formatTimestamp(booking?.orderedDate)}</span></td>
                                                        <td>{booking?.programName ? booking?.programName : "N/A"}</td>
                                                        <td><span className="t_text">
                                                        <div className='product_wide_card_img'>
                                                        { item?.image && <img src={item?.image[0]} className='h-25' />}
                                                        </div>
                                                        </span></td>
                                                        <td><span className="t_text">{item?.title}</span></td>
                                                        <td><span className="t_text">
                                                            {item?.sizes} /  {item?.color}
                                                        </span></td>
                                                        <td><span className="t_text">{item?.count}</span></td>
                                                        <td><span className="t_text">${item?.price?.toFixed(2)}</span></td>
                                                        <td><span className="t_text">{booking?.users?.name}</span></td>
                                                        <td><span className="t_text">{booking.bookingId && booking.programId && booking.camperId ? <Link to={`/bookings/${booking.bookingId}/${booking.camperId}/${booking.programId}`}>{booking.camperName}</Link> : booking.camperName}</span></td>
                                                        <td><span className="t_text">{booking?.users?.email}</span></td>
                                                        <td><span className="t_text">{booking?.transaction_id}</span></td>
                                                    </tr>

                                                )}
                                                </>
                                            ))
                                        }


                                    </tbody>
                                </table>

                            </div>

                            {
                                bookings?.length ? '' : <div className="mt-4 text-center cm_empty"><Empty description="Data Not Found" /></div>
                            }
                            </div>
                        }
                        </>
                    )}

                    {/* Additional Experience Bookings Table */}
                    {activeBookingType === BOOKING_TYPES.ADDITIONAL_EXPERIENCE && (
                        <>
                        {aeLoader ? <div className="program_loader"><ProgramLoader /></div> :
                        <div className="table_responsive_wrap mt-4 text-center">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped" id="section-to-print-ae">
                                    <thead>
                                        <tr>
                                            <th><span className="t_text">Booking Number</span></th>
                                            <th><span className="t_text">Booking Date</span></th>
                                            <th><span className="t_text">Program Name</span></th>
                                            <th><span className="t_text">Experience Title</span></th>
                                            <th>
                                                <span className="t_text" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                    Price
                                                    <span style={{ position: 'relative', display: 'inline-block' }}>
                                                        <span
                                                            className="info-icon-tooltip"
                                                            style={{
                                                                cursor: 'pointer',
                                                                color: '#17a2b8',
                                                                fontWeight: 'bold',
                                                                display: 'inline-block',
                                                                width: '18px',
                                                                height: '18px',
                                                                borderRadius: '50%',
                                                                border: '2px solid #17a2b8',
                                                                textAlign: 'center',
                                                                lineHeight: '14px',
                                                                fontSize: '12px'
                                                            }}
                                                        >
                                                            i
                                                        </span>
                                                        <span style={{
                                                            position: 'absolute',
                                                            top: '125%',
                                                            left: '50%',
                                                            transform: 'translateX(-50%)',
                                                            backgroundColor: '#333',
                                                            color: '#fff',
                                                            padding: '8px 12px',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            whiteSpace: 'nowrap',
                                                            opacity: 0,
                                                            visibility: 'hidden',
                                                            transition: 'opacity 0.3s, visibility 0.3s',
                                                            zIndex: 1000,
                                                            pointerEvents: 'none'
                                                        }}
                                                        className="hover-tooltip"
                                                        >
                                                            - Indicates the additional experience does not have an independent purchase
                                                        </span>
                                                    </span>
                                                </span>
                                            </th>
                                            <th><span className="t_text">Camper Name</span></th>
                                            <th><span className="t_text">Transaction Id</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {aeBookings.map((booking, i) => {
                                            // Check if there's a payment record with metadata.type = 'additionalExperiencePurchase'
                                            // that matches this additionalExperienceId
                                            const matchingPayment = booking.paymentArr?.find(payment =>
                                                payment.metadata?.type === 'additionalExperiencePurchase' &&
                                                payment.metadata?.purchasedAdditionalExperienceIds?.includes(booking.additionalExperienceId)
                                            );

                                            // Get booking date from matching payment or fallback to latest payment
                                            const latestPayment = booking.paymentArr?.length > 0
                                                ? booking.paymentArr.find(p => p.paymentStatus === 'succeeded') || booking.paymentArr[0]
                                                : null;

                                            return (
                                                <tr key={booking.additionalExperienceId + booking.camperId}>
                                                    <td><span className="t_text">{booking.bookingNumber || "N/A"}</span></td>
                                                    <td>
                                                        <span className="t_text">
                                                            {latestPayment?.paymentDate
                                                                ? formatTimestamp(latestPayment.paymentDate)
                                                                : "N/A"}
                                                        </span>
                                                    </td>
                                                    <td>{booking.programName || "N/A"}</td>
                                                    <td><span className="t_text">{booking.title || "N/A"}</span></td>
                                                    <td>
                                                        <span className="t_text">
                                                            {matchingPayment ? (
                                                                `$${parseFloat(matchingPayment.amount || 0).toFixed(2)}`
                                                            ) : (
                                                                '-'
                                                            )}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className="t_text">
                                                            {!(booking.bookingId && booking.programId && booking.camperId) ?
                                                                booking.camperName :
                                                                <Link to={`/bookings/${booking.bookingId}/${booking.camperId}/${booking.programId}`}>
                                                                    {booking.camperName}
                                                                </Link>
                                                            }
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className="t_text">
                                                            {matchingPayment ? (
                                                                matchingPayment.transaction_id || "N/A"
                                                            ) : (
                                                                '-'
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {aeBookings?.length ? '' : <div className="mt-4 text-center cm_empty"><Empty description="Data Not Found" /></div>}
                        </div>
                        }
                        </>
                    )}


                </div>
                <div className="d-flex justify-content-center mt-5">
                        <PaginatedComponent
                            activePage={activeBookingType === BOOKING_TYPES.PRODUCT ? page : aePage}
                            itemsCountPerPage={limit}
                            totalItemsCount={activeBookingType === BOOKING_TYPES.PRODUCT ? count : aeCount}
                            pageRangeDisplayed={3}
                            onPageChange={activeBookingType === BOOKING_TYPES.PRODUCT ? setPage : setAePage}/>
                    </div> 

            </div>


        </div>
        </>
    )
}


/*******************************
    Store Connect
********************************/

const mapStateToProps = state => {
    let { userProfile } = state?.user;
    let {f_productName,f_bookingDate,f_programName,f_tsize,f_userName,f_camperName,f_email,f_status} = state.allProductFilterState;
    return {
        state,
        userProfile,
        f_productName,
        f_bookingDate,
        f_programName,
        f_tsize,
        f_userName,
        f_camperName,
        f_email,
        f_status
    };
}

const mapDispatchToProps = dispatch => ({
    fProductNameFilterAction: params => dispatch(fProductNameFilterAction(params)),
    fBookingDateFilterAction: params => dispatch(fBookingDateFilterAction(params)),
    fTsizeFilterAction: params => dispatch(fTsizeFilterAction(params)),
    fUserNameFilterAction: params => dispatch(fUserNameFilterAction(params)),
    fCamperNameFilterAction: params => dispatch(fCamperNameFilterAction(params)),
    fEmailFilterAction: params => dispatch(fEmailFilterAction(params)),
    fProgramNameFilterAction: params => dispatch(fProgramNameFilterAction(params)),
    fStatusFilterAction: params => dispatch(fStatusFilterAction(params)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ProductBookings);

